export const calculateSuperelevationRunoffLength = (speedlimit, elevationChange, wheelbase, relativeVerticalSpeed) => {
    return (wheelbase * speedlimit * elevationChange)/(3.6 * relativeVerticalSpeed);
}